import { getLabel } from "../../common/getLabel";
import Pagination from "../../common/reactPaginate";
import TableSkeleton from "../../common/TableSkeleton";
const Listing = (props) => {
    const { error, blogs, loading, totalCount, handlePaginate, currentPage, limit, handleFormShow, handleStatus, deleteModalOpen, handleCheckboxChange, editBlog } = props;

    const handlePageClick = (selectedPage) => {
        handlePaginate(selectedPage);
    };
    const calculateSerialNumber = (index) => (currentPage - 1) * limit + index + 1;
    const totalPages = Math.ceil(totalCount / limit);

    return (
        <>
            <form id="blogTag-listing">
                <table className="table table-striped table-bordered" cellSpacing="0" width="100%">
                    <thead>
                        <tr>
                            {editBlog && (
                                <th className="col-check">
                                    <input type="checkbox" className="selectAll-js" onChange={(e) => handleCheckboxChange(e, "selectedlavel")} />
                                </th>
                            )}
                            <th className="table-id">{getLabel("LBL_Sr._No.")}</th>
                            <th>{getLabel("LBL_Blog_Name")}</th>
                            <th>{getLabel("LBL_Author")}</th>
                            <th>{getLabel("LBL_Status")}</th>
                            <th className="table-action">{getLabel("LBL_Action")}</th>

                        </tr>
                    </thead>
                    <tbody>

                        {loading ? (
                            <>
                                <TableSkeleton cards={limit} count={5} checkbox={true} />
                            </>
                        ) : error ? (
                            <tr className="no--record">
                                <td colspan="6" className="text-center">{getLabel("LBL_Some_thing_wrong_Please_try_again_later")}</td>
                            </tr>
                        ) : (
                            <>
                                {blogs && blogs.length > 0 ? (
                                    blogs.map((elem, index) => (
                                        <tr className="actions" key={index}>
                                            {editBlog && (
                                                <th>
                                                    <input
                                                        type="checkbox"
                                                        name="order_id_blog[]"
                                                        value={elem.blog_id}
                                                        className="selectItem--js"
                                                        onChange={(e) =>
                                                            handleCheckboxChange(e, elem.blog_id)
                                                        }
                                                    />
                                                </th>
                                            )}
                                            <td>{calculateSerialNumber(index)}</td>
                                            <td>
                                                <div className="verified-wrap">
                                                    <span className="user-profile_title">
                                                        {elem.blog_title}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="verified-wrap">
                                                    <span className="user-profile_title">
                                                        {elem.blog_author_name}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <label className="switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={elem.blog_status ? 1 : 0}
                                                        onChange={(e) =>
                                                            handleStatus(e, elem.blog_id, elem.blog_status)
                                                        }
                                                        disabled={!editBlog}
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                            </td>
                                            <td>
                                                <span className="action">
                                                    <ul>

                                                        <li>
                                                            <button type="button" onClick={() => handleFormShow(elem.blog_id)}>
                                                                <i className="bx bx-pencil" variant="primary" ></i>
                                                            </button>
                                                        </li>

                                                        {editBlog && (
                                                            <li>
                                                                <button type="button" onClick={() => deleteModalOpen(elem.blog_id)}>
                                                                    <i className="bx bx-trash" ></i>
                                                                </button>
                                                            </li>
                                                        )}

                                                    </ul>
                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr className="no--record">
                                        <td colspan="6" className="text-center">{getLabel("LBL_No_result_found")}</td>
                                    </tr>
                                )}
                            </>
                        )}
                    </tbody>
                </table>
            </form>
            {blogs && blogs.length > 0 && (
                <Pagination totalPages={totalPages} handlePageClick={handlePageClick} currentPage={currentPage} />
            )}
        </>
    );
};

export default Listing;
